// extracted by mini-css-extract-plugin
export var closeButton = "_jh-2";
export var closeButtonIcon = "_jh-3";
export var lightboxContent = "_jh-1";
export var lightboxOverlay = "_jh-0";